<template>
    <div v-if="!errors['no-update-date-partner'] && !errors['all-spots-are-taken-partner']">
        <div
            v-if="!errors['no-update-date'] && !errors['all-spots-are-taken']"
            class="mt-auto">
            <SendRequest 
                @hideModal = "hideModal" 
                :request="request"
            />
        </div>
        <ScheduleUpdate
            @hideModal = "hideModal"
            v-if="errors['all-spots-are-taken'] && !errors['no-update-date']"
            :campaign-id = "request.owner.selectedCampaign.id"
            button-text = "Add a Spot" />
    </div>
</template>

<script>
import { useErrors } from '../../../core/hooks'
import SendRequest from './SendRequest';
import ScheduleUpdate from './ScheduleUpdate';
import {ref} from '@vue/composition-api'
export default {
    name: 'SubmitButton',
    props: {
        request: Object,
        hideModal: Function
    },
    components: {
        ScheduleUpdate,
        SendRequest
    },
    setup(props){

        const errors = useErrors().messages;

        return {
            errors
        }
    }
}
</script>